module.exports = __webpack_public_path__ + "static/media/dog.bf6231bc.jpg";